import axios from '../../../axios';
import tmsMdmAxiosInstance from '@/tms-mdm-axios';
import tmsIndentAxiosInstance from '@/tms-indent-axios';

const actions = {
  async contract({ commit }, params) {
    try {
      commit('SET_CONTRACTS_LOADING', true);
      const result = await tmsIndentAxiosInstance.put('/order/routes', { data: params.data });
      if (result && result.data) {
        commit('SET_ALL_CONTRACTS', result.data);
      }
      return result.data;
    } catch (error) {
      return error;
    } finally {
      commit('SET_CONTRACTS_LOADING', false);
    }
  },

  async openVendors({ commit, state }) {
    const routes = state.openVendors;
    if (routes.length > 0) {
      return routes;
    }
    try {
      const result = await tmsMdmAxiosInstance('/transporter/active');
      if (result && result.data) {
        commit('SET_ALL_OPENVENDOR', result.data);
      }
      return result.data;
    } catch (error) {
      return error;
    }
  },
  async openVehicles({ commit, state }, params) {
    // const routes = state.openVehicles;
    // if (params.list === 'all' && routes.length > 0) {
    //   return routes;
    // }
    try {
      const result = await tmsMdmAxiosInstance('/vehicle_type', { params });
      if (result && result.data) {
        commit('SET_ALL_OPENVEHICLES', result.data);
      }
      return result.data;
    } catch (error) {
      return error;
    }
  },
};

export default actions;
